// extracted by mini-css-extract-plugin
export default {"supportTicketsHeader":"styles_supportTicketsHeader__bOk59","backBtn":"styles_backBtn__xbhyI","sportNameCircleIcon":"styles_sportNameCircleIcon__FixJ5","label":"styles_label__mgmyF"};